import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dateHelper from '../../../../utils/dateHelper.js';
import MessageParser from './MessageParser.js';
import Icon from '@material-ui/core/Icon';
import supports from '../../../../utils/SupportHelper.js';
import CopyMessageButton from './CopyMessageButton.js';

class NotifyMessage extends Component {
  /**
   * An notification message starts with "/notify ".
   **/
  static test(props) {
    return props.content.substr(0, 8) === '/notify ';
  }

  get content() {
    return this.props.content.substr(8);
  }

  render() {
    return (
      <div className="eyeson-chat-message notify">
        <div className="chat-avatar-wrap">
          <span className="icon-wrap icon-wrap__notify">
            <Icon className="icon-notify">new_releases</Icon>
          </span>
          {supports.ClipboardAPI && (
            <CopyMessageButton
              content={this.content}
              onEvent={this.props.onEvent}
            />
          )}
        </div>
        <div className="content">
          <span className="details">
            <strong className="username">{this.props.user.name}</strong>
            <span className="date">
              {dateHelper.formatTime(this.props.timestamp)}
            </span>
          </span>
          <MessageParser>{this.content}</MessageParser>
        </div>
      </div>
    );
  }
}

NotifyMessage.propTypes = {
  user: PropTypes.object.isRequired,
  content: PropTypes.string.isRequired,
};

export default NotifyMessage;
